import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({ tokens, px })=>({
        switchHeader: {
            display: 'flex',
            padding: tokens.spacing['16'],
            background: tokens.colors.bg.greyscale.primary,
            marginTop: 0,
            marginBottom: px(10)
        },
        iconButton: {
            padding: 0,
            color: tokens.colors.original.brand.primary,
            borderRadius: tokens.radius.s,
            border: `${tokens.border.s}px solid ${tokens.colors.stroke.primary}`,
            backgroundColor: 'none'
        },
        fadeContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1,
            overflow: 'hidden'
        },
        lable: {
            textTransform: 'capitalize'
        }
    }));
const CalendarHeader_styles = useStyles;
export default CalendarHeader_styles;
